import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

import Login from '../containers/Login';
import { getMe } from '../actions/userActions';
import Main from '../containers/Main';
import Initialization from './Initialization';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn } = rest;
  return (
    <Route
      {...rest}
      render={(props) => {
    return isLoggedIn === true
      ? <Initialization><Component {...props} /></Initialization>
      : (
        <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
        }}
        />
      )
    }}
    />
  )
};

class Root extends Component {
  constructor(props) {
    super(props);
    props.dispatch(getMe());
  }

  render() {
    const { isLoggedIn, isFetching, userInfo } = this.props;
    localStorage.setItem('user', userInfo.email);

    return (
      <div>
        <Switch>
          <Route exact path="/login" component={Login} />
          <PrivateRoute
            path="/"
            component={Main}
            isLoggedIn={isLoggedIn}
            isFetching={isFetching}
          />
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { user, notificationRequest } = state;
  return {
    isFetching: user.isFetching,
    isLoggedIn: user.isLoggedIn,
    userInfo: {
      name: user.displayName,
      email: user.email
    },
    notification: notificationRequest
  }
};

export default withRouter(connect(mapStateToProps)(Root));
